<!--
* @Name：合同付款任务信息页面
* @Author: LiHao
* @Date: 2025-06-25
-->
<template>
  <div>
    <hi-cell title="申请单号：" :value="headInfo.docNo"></hi-cell>
    <hi-cell title="申请人：" :value="headInfo.crtUserName"></hi-cell>
    <hi-cell title="申请时间：" :value="headInfo.crtTime"></hi-cell>
    <hi-cell title="供应商名称：" :value="headInfo.suppName"></hi-cell>
    <hi-cell title="合同编号：" :value="headInfo.contractNo"></hi-cell>
    <hi-cell title="付款任务类型：" :value="headInfo.payTaskType" :options="payTaskTypeOptions"></hi-cell>
    <hi-cell title="合同总金额：" :value="headInfo.contractAmount"></hi-cell>
    <hi-cell title="已付款金额：" :value="headInfo.totalPayedAmount"></hi-cell>
    <hi-cell title="本次付款金额：" :value="headInfo.payAmount"></hi-cell>
    <hi-cell title="本次付款比例%：" :value="headInfo.payPercent"></hi-cell>
    <hi-cell title="付款说明：" :value="headInfo.payRemark"></hi-cell>
  </div>
</template>

<script>
export default {
  name: 'BaseInfo',
  components: {},
  data() {
    return {}
  },
  props: {
    headInfo: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    payTaskTypeOptions() {
      return this.$store.getters.dicts.pay_order_type
    }
  }
}
</script>
